<script setup lang="ts">
import { useAttrs } from 'vue';
import ItpFormSelect from './ItpFormSelect.vue';

defineOptions({ name: 'ItpFormNativeSelect', inheritAttrs: false });

const props = defineProps<{ name: string }>();

const SEARCHABLE_ONLY = [
  'dataSource',
  'prefetch',
  'clearable',
  'optionTemplate',
  'taggable',
  'filterable',
  'filterBy',
];
if (import.meta.env.DEV) {
  const attrs = useAttrs();
  const ignored = SEARCHABLE_ONLY.filter(
    (name) => attrs[name] != null && attrs[name] !== false,
  );
  if (String(attrs.textField ?? '').includes(',')) {
    ignored.push(`textField "${attrs.textField}"`);
  }
  if (ignored.length) {
    console.warn(
      `ItpFormNativeSelect "${props.name}": ${ignored.join(', ')} only works in ItpFormSearchableSelect.`,
    );
  }
}
</script>

<template>
  <ItpFormSelect v-bind="$attrs" :name="props.name" mode="native">
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </ItpFormSelect>
</template>
